import { Col, Form, Row, Input } from "antd";

const NotificationSettingsFilterFields = ({ initialTableData }) => {
  return (
    <>
      <Col span={4}>
        <Form.Item label="Name" name="name">
          <Input placeholder="Name" size="small"/>
        </Form.Item>
      </Col>
    </>
  );
};

export default NotificationSettingsFilterFields;
